import React, { useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import DayWiseFollowUp from './DayWiseFollowUp';
import ServiceReminder from './ServiceReminder';

function Followups() {
  const [activeComponent, setActiveComponent] = useState('DaywiseFollowups');

  const handleToggleChange = (event, newComponent) => {
    if (newComponent) {
      setActiveComponent(newComponent);
    }
  };

  return (
    <PageContainer title="Follow-ups" description="This is Follow-ups">
      <DashboardCard2 title="Follow-ups">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px', marginBottom: '1rem' }}>
            <ToggleButtonGroup
              value={activeComponent}
              exclusive
              onChange={handleToggleChange}
              sx={{
                borderRadius: '30px',
                height: '40px',
                backgroundColor: '#f0f0f0',
                border: '1px solid #cfcece',
                display: 'flex',
                gap: '2px',
                marginLeft: '0rem',
              }}
            >
              <ToggleButton
                value="DaywiseFollowups"
                sx={{
                  color: '#000',
                  backgroundColor: '#fafafa',
                  padding: '0 20px',
                  borderRadius: '30px',
                  border: 'none',
                  '&.Mui-selected': {
                    backgroundColor: '#6174DD',
                    color: '#fff',
                    border: 'none',
                    '&:hover': {
                      backgroundColor: '#6174DD',
                    },
                  },
                  '&:not(.Mui-selected)': {
                    '&:hover': {
                      backgroundColor: '#d0d0d0',
                    },
                  },
                }}
              >
Client Follow-Up Insights              </ToggleButton>
              <ToggleButton
                value="ServiceReminder"
                sx={{
                  color: '#000',
                  backgroundColor: '#fafafa',
                  padding: '0 20px',
                  borderRadius: '30px',
                  border: 'none',
                  '&.Mui-selected': {
                    backgroundColor: '#6174DD',
                    color: '#fff',
                    border: 'none',
                    '&:hover': {
                      backgroundColor: '#6174DD',
                    },
                  },
                  '&:not(.Mui-selected)': {
                    '&:hover': {
                      backgroundColor: '#d0d0d0',
                    },
                  },
                }}
              >
                Service Reminders
              </ToggleButton>
            </ToggleButtonGroup>
          </div>

          <div className="content">
            {activeComponent === 'DaywiseFollowups' && <DayWiseFollowUp />}
            {activeComponent === 'ServiceReminder' && <ServiceReminder />}
          </div>
        </div>
      </DashboardCard2>
    </PageContainer>
  );
}

export default Followups;
